// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = require('../internals/add-to-unscopables');

addToUnscopables('flat');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es.array.unscopables.flat.js
// module id = 344
// module chunks = 48